exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pop-icon[data-v-4f0084cb] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  overflow: hidden;\n  min-height: 55px;\n}\n.pop-icon .img-icon[data-v-4f0084cb] {\n  cursor: pointer;\n  max-width: 187px;\n}\n.pop-icon .img-icon[data-v-4f0084cb] .el-icon-picture {\n  border: 1px solid #d4d4d4;\n  width: 50px;\n  height: 50px;\n  line-height: 50px;\n  text-align: center;\n}\n", ""]);

// exports
